import React from "react";
import Button from "../components/Button";
// import { Link } from "react-router-dom";

const ThankYouPage = () => {
  const tripName = sessionStorage.getItem("tripName");

  const handleSubmit = () => {
    const parts = tripName.split("-");
    parts.pop(); // remove last part
    const tripNameWithoutDate = parts.join("-");

    window.location.href = `https://biblicaltouring.com/${tripNameWithoutDate}`;

    localStorage.clear();
    // sessionStorage.clear();
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      <div className="w-24 h-24 rounded-full bg-green-500 flex items-center justify-center shadow-lg">
        <span className="text-white text-5xl">&#10003;</span>
      </div>
      <h1 className="sm:w-full w-[80%] text-center mx-auto my-6 text-lg font-semibold text-gray-800">
        Your journey of faith begins now. Thank you for registering with
        Biblical Touring — we’re honored to walk this path with you.
      </h1>
      {/* <Link
        to={`${
          tripName.includes("greece")
            ? "https://biblicaltouring.com/greece-dev/"
            : "https://biblicaltouring.com/turkey-dev/"
        }`}
      > */}
      <Button
        className={`bg-green-500 text-white`}
        onClick={handleSubmit}
        text="HOME"
      />
      {/* </Link> */}
    </div>
  );
};

export default ThankYouPage;
